/** "Include in timeline" toggles for the Medical Record tab. */

export const MEDICAL_RECORD_DISPLAY_FILTER = {
  futureAppointments: 'future-appointments',
  assessments: 'assessments',
  psychotherapyNotes: 'psychotherapy-notes',
  /** When selected, include SP historical migration records on the timeline. */
  historical: 'historical',
} as const;

/**
 * Assessments and historical records are part of the chart story, so the timeline opens
 * with both included; future appointments and psychotherapy notes stay opt-in.
 */
export const DEFAULT_DISPLAY_FILTER: string[] = [
  MEDICAL_RECORD_DISPLAY_FILTER.assessments,
  MEDICAL_RECORD_DISPLAY_FILTER.historical,
];

export function timelineShowsHistorical(displayFilter: readonly string[]): boolean {
  return displayFilter.includes(MEDICAL_RECORD_DISPLAY_FILTER.historical);
}

/** Historical items drop off the timeline when Historical is unticked. */
export function shouldShowWhenHistoricalFilter(
  historicalSelected: boolean,
  itemIsHistorical: boolean,
): boolean {
  return historicalSelected || !itemIsHistorical;
}
